import { Box, Fade, Link, Typography } from '@mui/material'
import { useLayoutEffect, useState } from 'react'
import { createPortal } from 'react-dom'
import FormControls from './FormControls'

const storageKey = 'neroli-salon-salon-keyword'

export default function MainContent({
  hasSalon,
  keyword,
  logoUrl,
}: {
  hasSalon: boolean
  keyword: string
  logoUrl: string
}) {
  const [isUnlocked, setIsUnlocked] = useState(() => {
    if (!hasSalon) {
      return true
    }
    return localStorage.getItem(storageKey) === keyword
  })
  const [isOverlayMounted, setIsOverlayMounted] = useState(() => !isUnlocked)

  useLayoutEffect(() => {
    document.body.classList.remove('neroli-salon-loading')
  }, [])

  if (!isOverlayMounted) {
    return null
  }

  return createPortal(
    <Fade in={!isUnlocked} timeout={400} appear={false} onExited={() => setIsOverlayMounted(false)}>
      <Box
        sx={{
          position: 'fixed',
          left: '0',
          top: '0',
          width: '100lvw',
          height: '100lvh',
          zIndex: '100000',
          padding: '0 20px 15lvh',
          backgroundColor: (theme) => theme.palette.background.default,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Box
          sx={{
            width: '100%',
            maxWidth: '400px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
          }}
        >
          <Box
            component="img"
            src={logoUrl}
            alt={document.title}
            sx={{
              width: '70%',
              margin: '0 auto 48px',
            }}
          />
          <Typography
            component="p"
            variant="body1"
            sx={{
              margin: '0 0 32px',
              textAlign: 'center',
              fontSize: '16px',
              color: (theme) => theme.palette.primary.main,
            }}
          >
            こちらの商品はサロン会員専用です。
            <br />
            会員の方はパスワードをご入力ください。
          </Typography>

          <FormControls
            keyword={keyword}
            didSuccess={() => {
              localStorage.setItem(storageKey, keyword)
              setIsUnlocked(true)
            }}
          />

          <Box sx={{ display: 'flex', alignItems: 'center', gap: '24px' }}>
            <Link
              component="button"
              type="button"
              sx={{
                textDecoration: 'underline !important',
                height: '1.5em',
                lineHeight: '1.5em',
                padding: '0',
                display: 'block',
                fontFamily: 'Cormorant, serif',
                fontSize: '17px',
                color: (theme) => theme.palette.primary.main,
              }}
              onClick={() => window.history.back()}
            >
              戻る
            </Link>

            <Typography
              component="span"
              variant="body1"
              sx={{
                textAlign: 'center',
                fontSize: '16px',
                color: (theme) => theme.palette.primary.main,
              }}
            >
              |
            </Typography>

            <Link
              href="/"
              sx={{
                textDecoration: 'underline !important',
                height: '1.5em',
                lineHeight: '1.5em',
                padding: '0',
                display: 'block',
                fontFamily: 'Cormorant, serif',
                fontSize: '18px',
                color: (theme) => `${theme.palette.primary.main} !important}`,
              }}
            >
              TOP
            </Link>
          </Box>
        </Box>
      </Box>
    </Fade>,
    document.body,
  )
}
